import Vue from 'vue';

export default {
    async register(options = { username, password, language, currency, recaptchaResponse, ip }) {
        return (await Vue.http.post('/api/v2/registration', options)).data;
    },
    // async registerByPhone(options = { phone, password, username, messenger, language, recaptchaResponse }) {
    //     return (await Vue.http.post('/api/v2/registration/phone', options)).data;
    // },
    async confirmPhone(options = { code, phone, ip }) {
        return (await Vue.http.post('/api/v2/registration/phone/confirm', options)).data;
    },
    async changePassword(oldPassword, newPassword) {
        return (await Vue.http.post('/api/v2/registration/password/change', { oldPassword, newPassword })).data;
    },
    async restorePasswordByPhone(phone, recaptchaResponse) {
        return (await Vue.http.post('/api/v2/registration/phone/password/restore', { phone, recaptchaResponse })).data;
    },
    async registerByPhone(
        options = { phone, firstName, lastName, dateOfBirth, password, username, messenger, language, recaptchaResponse }
    ) {
        return (await Vue.http.post('/api/v2/registration/phone', options)).data;
    },
    async registerByEmail(options = { type, email, firstName, lastName, dateOfBirth, password, alias, currency, site }) {
        return (await Vue.http.post('/api/v2/registration/email', options)).data;
    },
    async confirmEmail(options = { type, email, code, ip }) {
        return (await Vue.http.post('/api/v2/registration/email/confirm', options)).data;
    },
    async restorePasswordByEmail(options = { email, recaptchaResponse }) {
        return (await Vue.http.post('/api/v2/registration/email/password/restore', options)).data;
    }
};



// WEBPACK FOOTER //
// ./_common/services/registration.service.js